export default {

  created() {
    if(!this.$breakpoints) throw new Error('App dimensions plugin requires "breakpoints" plugin to be installed')
  },

  computed: {

    appHeaderHeight() {
      switch(this.$breakpoints.current) {
        case 'xs':
        case 'sm': return 46; break;
        case 'md': return 64; break;
        case 'lg': return 72; break;
        case 'xl': return 81; break;
      }
    },

    headerHeight() {
      switch(this.$breakpoints.current) {
        case 'xs':
        case 'sm': return 46; break;
        case 'md': return 49; break;
        case 'lg': return 56; break;
        case 'xl': return 63; break;
      }
    },

    footerHeight() {
      return this.headerHeight
    },

  }
}
